import {Route,Switch,BrowserRouter } from "react-router-dom";

import OrdersTable from "components/Doobi/Orders";
import DoobiHeader from "components/Headers/DoobiHeader";
import OrderDetailsPage from "components/Doobi/OrderDetails";
import OrderBagUpdatesTable from "components/Doobi/OrderBagUpdates";
import BagWeightTable from "components/Doobi/BagWeightReport";

const OrdersRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Orders" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/report/weight`} component={BagWeightTable}/>
      <Route path={`${match.path}/bagUpdates`} component={OrderBagUpdatesTable}/>
      <Route path={`${match.path}/subscription/:id`} component={OrdersTable}/>
      <Route path={`${match.path}/subscription`} component={OrdersTable}/>
      <Route path={`${match.path}/:id`} component={OrderDetailsPage}/>
      <Route path={`${match.path}/`} component={OrdersTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default OrdersRoute;
